<template>
  <div>
    <view-upload v-if="viewActive" :src="viewSrc" />
    <vx-card card-border no-shadow :title="title" id="upload-file">
      <slot />
      <div class="con-upload" :class="{ touch_device: $store.state.is_touch_device }">
        <div class="con-img-upload">
          <!-- <transition-group v-for="(img,index) in getFilesFilter" :key="index" name="upload"> -->
          <div
            v-for="(file, index) in files"
            :class="{
              fileError: file.error && file.error !== 'compressing'
            }"
            :key="index"
            class="img-upload"
          >
            <div
              class="btn-x-file"
              v-if="file.active"
              @click.prevent="
                file.active ? $refs.upload.update(file, { error: 'cancel', active: false }) : false
              "
            >
              <i translate="no" class="material-icons notranslate"> close </i>
            </div>
            <div class="btn-x-file" v-else @click.prevent="$refs.upload.remove(file)">
              <i translate="no" class="material-icons notranslate"> delete </i>
            </div>

            <div
              class="btn-x-file btn-edit-file"
              v-if="!(file.active || file.success || file.error === 'compressing')"
              @click.prevent="
                file.active || file.success || file.error === 'compressing' ? false : onEditFileShow(file)
              "
            >
              <i translate="no" class="material-icons notranslate"> edit </i>
            </div>

            <div
              class="btn-x-file btn-retry-file"
              v-if="!file.active && file.error && file.error !== 'compressing' && $refs.upload.features.html5"
              @click.prevent="$refs.upload.update(file, { active: true, error: '', progress: '0.00' })"
            >
              <i translate="no" class="material-icons notranslate"> cloud_upload </i>
            </div>

            <div
              class="btn-x-file btn-retry-file"
              v-else-if="
                !(file.active || file.success || file.error === 'compressing') && $store.state.is_touch_device
              "
              @click.prevent="$refs.upload.update(file, { active: true })"
            >
              <i translate="no" class="material-icons notranslate"> cloud_upload </i>
            </div>

            <button
              :class="{
                'on-progress': file.active || file.success || (file.error && file.error !== 'compressing'),
                'ready-progress':
                  (file.progress == 100 && !file.active && file.success) ||
                  (file.error && file.error !== 'compressing')
              }"
              :style="{
                height: `100%`
              }"
              class="btn-upload-file"
              @click.prevent="
                file.success || file.error === 'compressing'
                  ? false
                  : $refs.upload.update(file, { active: true })
              "
            >
              <i translate="no" class="material-icons notranslate">
                {{
                  file.progress >= 100 && !file.active
                    ? file.error && file.error !== 'compressing'
                      ? 'report_problem'
                      : 'cloud_done'
                    : 'cloud_upload'
                }}
              </i>
              <span v-if="file.active">
                <i class="fa fa-2x fa-spinner fa-spin" />
              </span>
            </button>
            <img
              v-if="file.thumb"
              :style="{
                maxWidth: file.orientation === 'h' ? '100%' : 'none',
                maxHeight: file.orientation === 'w' ? '100%' : 'none'
              }"
              :key="index"
              :src="file.thumb"
              @touchend="viewImage(file.thumb, $event)"
              @click="viewImage(file.thumb, $event)"
              :alt="file.thumb"
            />
            <h4 v-if="!file.thumb" class="text-archive">
              <i translate="no" class="material-icons notranslate"> description </i>
              <span>
                {{ file.name }}
              </span>
            </h4>
          </div>
          <!-- </transition-group > -->

          <div class="con-input-upload">
            <file-upload
              :extensions="extensions"
              :accept="accept"
              :multiple="multiple"
              :directory="directory"
              :size="size || 0"
              :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
              :drop="drop"
              :drop-directory="dropDirectory"
              :add-index="addIndex"
              v-model="files"
              @input-filter="inputFilter"
              @input-file="inputFile"
              :post-action="postAction"
              ref="upload"
              :headers="headers"
            >
              <div class="text-center p-5">
                <h5>{{ $t('upload_files.drop_to_upload') }}<br />{{ $t('upload_files.or') }}</h5>
                <span class="btn btn-lg btn-primary">{{ $t('upload_files.select') }}</span>
              </div>
            </file-upload>
            <button
              :disabled="files.length === 0"
              type="button"
              title="Upload"
              class="btn-upload-all vs-upload--button-upload"
              @click.prevent="$refs.upload.active = true"
            >
              <i translate="no" class="material-icons notranslate"> cloud_upload </i> <br />
              {{ this.multiple ? $t('upload_files.upload_files') : $t('upload_files.upload_file') }}
            </button>
          </div>
        </div>
      </div>
      <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
        <h3>{{ $t('upload_files.drop_to_upload') }}</h3>
      </div>

      <slot name="footer" />
      <vs-popup
        :active.sync="editFile.show"
        id="popup-edit-file"
        tabindex="-1"
        :fullscreen="
          editFile.show && editFile.blob && editFile.type && editFile.type.substr(0, 6) === 'image/'
        "
        :title="$t('upload_files.edit_file')"
      >
        <form>
          <div class="vx-row mb-3">
            <div class="vx-col w-full md:w-1/2">
              <label for="name">{{ $t('upload_files.file_name') }}:</label>
              <vs-input
                type="text"
                required
                class="w-full"
                id="name"
                placeholder="Please enter a file name"
                v-model="editFile.name"
              />
            </div>

            <vs-row vs-justify="flex-end" class="vx-col w-full md:w-1/2">
              <vs-button @click.prevent="editFile.show = false" type="border" color="danger" class="mr-2">
                {{ $t('forms.cancel') }}
              </vs-button>
              <vs-button @click.prevent="onEditorFile" type="border" color="success">{{
                $t('forms.save')
              }}</vs-button>
            </vs-row>
          </div>
          <div
            class="vx-col w-full mb-3"
            v-if="editFile.show && editFile.blob && editFile.type && editFile.type.substr(0, 6) === 'image/'"
          >
            <label>{{ $t('upload_files.image') }}: </label>
            <div class="vx-row">
              <vs-button @click="editFile.cropper.rotate(-90)" size="small" type="flat" class="mr-2">
                <i translate="no" class="material-icons notranslate"> rotate_left </i>
              </vs-button>
              <vs-button @click="editFile.cropper.rotate(90)" size="small" type="flat" class="mr-2">
                <i translate="no" class="material-icons notranslate"> rotate_right </i>
              </vs-button>
              <vs-button @click="editFile.cropper.setDragMode('crop')" size="small" type="flat" class="mr-2">
                <i translate="no" class="material-icons notranslate"> crop </i>
              </vs-button>
              <vs-button @click="editFile.cropper.clear()" size="small" type="flat" class="mr-2">
                <i translate="no" class="material-icons notranslate"> clear </i>
              </vs-button>
              <vs-button @click="editFile.cropper.setDragMode('move')" size="small" type="flat" class="mr-2">
                <i translate="no" class="material-icons notranslate"> pan_tool </i>
              </vs-button>
            </div>

            <div class="edit-image mb-3" dir="ltr">
              <img :src="editFile.blob" ref="editImage" />
            </div>
          </div>
        </form>
      </vs-popup>
    </vx-card>
  </div>
</template>
<style lang="scss">
/* prettier-ignore */
[dir=rtl] {
  .cropper-container {
    direction: ltr;
  }
}
.edit-image img {
  max-width: 100%;
}
.con-img-upload .img-upload {
  .btn-edit-file {
    right: 35px;
  }
  .btn-edit-file:hover ~ .btn-upload-file:not(.on-progress) {
    background: radial-gradient(ellipse at center, rgba(var(--vs-warning), 1) 0, transparent 70%);
  }
  .btn-edit-file:hover i {
    background: rgba(var(--vs-warning), 1);
  }

  .btn-retry-file {
    right: 65px;
  }
  .btn-retry-file:hover ~ .btn-upload-file:not(.on-progress) {
    background: radial-gradient(ellipse at center, rgba(var(--vs-success), 1) 0, transparent 70%);
  }
  .btn-retry-file:hover i {
    background: rgba(var(--vs-success), 1);
  }
}
.drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: absolute;
  z-index: 9999;
  opacity: 0.3;
  text-align: center;
  background: #000;
  margin: 10px;
  border: dashed 3px #ffffff;

  h3 {
    margin: -0.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
}
.touch_device {
  .con-img-upload .img-upload {
    .btn-x-file {
      opacity: 1;
      -webkit-transform: translate(0);
      transform: translate(0);
    }
  }
}
</style>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import ImageCompressor from '@xkeshi/image-compressor'
import FileUpload from 'vue-upload-component'
import ViewUpload from '@/components/cteb-upload/View'
import { baseURL } from '@/axios'
import i18n from '@/i18n/i18n'

let lastTap = 0

export default {
  components: {
    ViewUpload,
    FileUpload
  },
  props: {
    title: {
      type: String,
      default: i18n.t('upload_files.upload_files')
    },
    startUpload: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default:
        'image/png,image/gif,image/jpeg,image/webp,application/zip,application/octet-stream,application/x-rar,application/x-rar-compressed,application/pdf'
    },
    extensions: {
      type: String,
      default: 'gif,jpg,jpeg,png,webp,zip,rar,pdf'
    },
    uploadAuto: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    directory: {
      type: Boolean,
      default: false
    },
    drop: {
      type: Boolean,
      default: true
    },
    dropDirectory: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      files: [],
      uploaded_files: [],
      // extensions: ['gif', 'jpg', 'jpeg','png', 'webp'],
      // extensions: /\.(gif|jpe?g|png|webp)$/i,
      addIndex: false,
      minSize: 1024,
      size: 1024 * 1024 * 10,
      autoCompress: 1024 * 1024,
      thread: 3,
      addData: {
        show: false,
        name: '',
        type: '',
        content: ''
      },
      editFile: {
        show: false,
        name: ''
      },
      viewActive: false,
      viewSrc: '',

      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken') ||
          sessionStorage.getItem('accessToken')}`
      },

      uploading: 0
    }
  },
  computed: {
    postAction() {
      return `${baseURL}uploads`
    },
    pendingUpload() {
      return !(!this.files.filter(f => !f.success & (f.error === '')).length && !this.uploading)
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.upload.uploading
      },
      value => {
        this.uploading = value
        this.$emit('uploading', value)
      }
    )
  },
  watch: {
    startUpload(value) {
      if (value) {
        this.$refs.upload.active = true
        this.$nextTick(() => {
          // eslint-disable-next-line vue/no-mutating-props
          this.startUpload = false
        })
      }
    },
    pendingUpload(value) {
      this.$emit('pending-upload', value)
    },
    'editFile.show'(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.$refs.upload.update(this.editFile.id, { error: this.editFile.error || '' })
      }
      if (newValue) {
        this.$nextTick(function() {
          if (!this.$refs.editImage) {
            return
          }
          let cropper = new Cropper(this.$refs.editImage, {
            autoCrop: false
          })
          this.editFile = {
            ...this.editFile,
            cropper
          }
        })
      }
    },
    'addData.show'(show) {
      if (show) {
        this.addData.name = ''
        this.addData.type = ''
        this.addData.content = ''
      }
    }
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
        // Automatic compression
        if (
          newFile.file &&
          newFile.type.substr(0, 6) === 'image/' &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          newFile.error = 'compressing'
          const imageCompressor = new ImageCompressor(null, {
            convertSize: Infinity,
            maxWidth: 512,
            maxHeight: 512
          })
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.upload.update(newFile, { error: '', file, size: file.size, type: file.type })
            })
            .catch(err => {
              this.$refs.upload.update(newFile, { error: err.message || 'compress' })
            })
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
        // Thumbnails
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
          let img = document.createElement('img')
          img.onload = () => {
            this.$refs.upload.update(newFile, { orientation: img.width > img.height ? 'w' : 'h' })
          }
          img.src = newFile.blob
        }
      }
    },
    // add, update, remove File Event
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          // min size
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.upload.update(newFile, { error: 'size' })
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
        }
        if (newFile.success && !oldFile.success) {
          // success
          this.$notifySuccess(this.$t('upload_files.successfully_uploaded'))
          this.uploaded_files.push(newFile.response[0].id)
          this.$emit('input', this.multiple ? this.uploaded_files : this.uploaded_files[0])
          this.$nextTick(() => {
            if (!this.pendingUpload) this.$emit('upload-complete', true)
          })
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response[0].id) {
          this.$store.dispatch('file/removeFile', oldFile.response[0].id).then(() => {
            this.$notifySuccess(this.$t('upload_files.successfully_deleted'))

            this.uploaded_files.splice(this.uploaded_files.indexOf(oldFile.response[0].id), 1)
            this.$emit('input', this.multiple ? this.uploaded_files : this.uploaded_files[0])
          })
        }
      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    onEditFileShow(file) {
      this.editFile = { ...file, show: true }
      this.$refs.upload.update(file, { error: 'edit' })
    },
    onEditorFile() {
      if (!this.$refs.upload.features.html5) {
        this.$notifyError(this.$t('upload_files.browser_does_not_support'))
        this.editFile.show = false
        return
      }
      let data = {
        name: this.editFile.name
      }
      if (this.editFile.cropper) {
        let binStr = atob(
          this.editFile.cropper
            .getCroppedCanvas()
            .toDataURL(this.editFile.type)
            .split(',')[1]
        )
        let arr = new Uint8Array(binStr.length)
        for (let i = 0; i < binStr.length; i++) {
          arr[i] = binStr.charCodeAt(i)
        }
        data.file = new File([arr], data.name, { type: this.editFile.type })
        data.size = data.file.size
      }
      this.$refs.upload.update(this.editFile.id, data)
      this.editFile.error = ''
      this.editFile.show = false
    },
    // add folder
    onAddFolder() {
      if (!this.$refs.upload.features.directory) {
        this.$notifyError(this.$t('upload_files.browser_does_not_support'))
        return
      }
      let input = this.$refs.upload.$el.querySelector('input')
      input.directory = true
      input.webkitdirectory = true
      // eslint-disable-next-line vue/no-mutating-props
      this.directory = true
      input.onclick = null
      input.click()
      // eslint-disable-next-line no-unused-vars
      input.onclick = e => {
        // eslint-disable-next-line vue/no-mutating-props
        this.directory = false
        input.directory = false
        input.webkitdirectory = false
      }
    },
    onAddData() {
      this.addData.show = false
      if (!this.$refs.upload.features.html5) {
        this.$notifyError(this.$t('upload_files.browser_does_not_support'))
        return
      }
      let file = new window.File([this.addData.content], this.addData.name, {
        type: this.addData.type
      })
      this.$refs.upload.add(file)
    },
    toSize(size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
      } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      }
      return size.toString() + ' B'
    },
    viewImage(src, evt) {
      let timeout
      let eventx =
        'ontouchstart' in window || (window.DocumentTouch && document instanceof window.DocumentTouch)
          ? 'touchstart'
          : 'click'
      if (eventx === 'click') {
        this.viewActive = true
        this.viewSrc = src
      } else {
        if (evt.type === 'touchend') {
          let currentTime = new Date().getTime()
          let tapLength = currentTime - lastTap
          clearTimeout(timeout)
          if (tapLength < 500 && tapLength > 0) {
            this.viewActive = true
            this.viewSrc = src
            event.preventDefault()
          }
          lastTap = currentTime
        }
      }
    }
  }
}
</script>
